import HTTP from '../../Infra/Http'


export const addUserPlant = async (plantData) => {
  return await HTTP.Post('/api/user-plants/', plantData);
};

export const getUserPlants = async () => {
  return await HTTP.Get('/api/user-plants/');
};

export const getUserPlantById = async (id) => {
  return await HTTP.Get(`/api/user-plants/item/${id}`);
};

export const updateUserPlant = async (id, plantData) => {
  return await HTTP.Put(`/api/user-plants/${id}`, plantData);
};

export const deleteUserPlant = async (id) => {
  return await HTTP.Delete(`/api/user-plants/${id}`);
};

export const registerWatering = async (id) => {
  return await HTTP.Post(`/api/user-plants/${id}/water`);
};


export const checkEligibility = async (id,obj) => {
  return await HTTP.Post(`/api/user-plants/eligible/${id}`,obj);
};

export const myReminders = async () => {
  return await HTTP.Get(`/api/user-plants/myreminders`);
};

